/**
 * @Author: zhengpengcheng
 * @Description:
 * @DateTime: Created in 2022-11-09 14:23:00
 */

 import {Component} from 'vue-property-decorator';
 import OperatingKeyService from './service/operatingKeyService';
 import BasicSearchPage from "../../../components/basicSearchPage/basicSearchPage";
 import override from "../../../dectorators/override";
 import { OperatingKeyDOI } from './api/operatingKey';
 
 @Component
 export default class OperatingKey extends BasicSearchPage<OperatingKeyService, OperatingKeyDOI.RowDataI, OperatingKeyDOI.QueryRowDataParamsI> {
     checkBoxShow = false
     className='wqms-pt0'
     @override
     loadService () {
         this.service = new OperatingKeyService(this)
     }
     
 }